import apiUrl from "../../../constants";
import axios from "axios";
import iptrackerdetails from '../../../iptrackerdetails'

import Paginate from "vuejs-paginate";
import CryptoJS from 'crypto-js';
import {
  Validator
} from "vee-validate";
import VueElementLoading from 'vue-element-loading';

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  name: "apppermissions",
  components: {
    Paginate,
    VueElementLoading,
    Multiselect
  },
  data: function() {
    return {
      modalShow: false,
      updaterolemodal: false,
      editrolemodal: false,
      addpermissionmodal: false,
      permissionaction: "",
      iptrackData:'',
      listPermissionsData: [],
      listPermissionData: [],
      permissionid: [],
      pageno: 0,
      pagecount: 0,
      permissionname: "",
      searchpermissionname: (!(window.localStorage.getItem("LSPermission"))) ? ""  : window.localStorage.getItem('LSPermission'),
      searchprojectid: (( window.localStorage.getItem('LSProjectId')) == 'undefined' || ( window.localStorage.getItem('LSProjectId')) == null) ? '' : this.fillProjectData(),
      perm_id: [],
      roleid: [],
      projectid: 0,
      parentid: 0,
      devicetype: '',
      isLoading: false,
      resultCount: '',
      model: {
        name: "",
        username: ""
      },
      addpermission: {
        permissionname: "",
        perm_name: "",
        controller_url: "",
        purl: "",
        is_active:"",
        ismenu: "",
        isEven:false,
        backgroundColor:null,
        textColor:null

      },
      checkedPerm_Id: [],
      projectid: [],
      listProjectData: [],
      listRolesData: [],
      selected: '',
      changestatus: ''
    };
  },

  created: function() {},
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail');
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.iptrackData = userdetail
    this.localuserid = userdetail.userid;
    this.localusername = userdetail.username;
    this.getPermisionData();
    this.getAllProjectList();
    //this.getProjectRoles_list();
  },
  methods: {
    fillProjectData(){
      var projectFill = [];
      projectFill = {
        projectid : window.localStorage.getItem('LSProjectId'),
        projectname : window.localStorage.getItem('LSProject')
      }
      this.listProjectData = projectFill;
      return projectFill;
    },
    addNewpermission() {
      this.addpermission.perm_name= "";
      this.addpermission.controller_url= "";
      this.addpermission.purl= "";
      this.addpermission.is_active=true;
      this.addpermission.sequence="";
      this.addpermission.permissionname="";
      this.addpermission.permissionid = "";
      this.addpermission.isEven = false;
      this.addpermission.backgroundColor = null;
      this.addpermission.textColor = null;
      this.roleid= [];
      this.listRolesData= [];
      this.projectid= 0;
      this.devicetype= "";
      this.checkedPerm_Id = [];
      this.addpermission.ismenu=true;
      this.permissionaction = "add";
      this.addpermissionmodal = true;
      this.$validator.reset();
      this.errors.clear();
    },
    closeAddPermissionModal() {
      $("#appmoduleform").trigger("reset");
      this.projectid=[];
      this.devicetype= "";
      this.is_active ="";
      this.ismenu = "";
      this.checkedPerm_Id = [];
      this.listPermissionData= [];
      this.permissionid= [];
      this.addpermissionmodal = false;
      this.$validator.reset();
      this.errors.clear();
      this.resetform();
    },

    closeEditRoleModal() {
      this.addpermissionmodal = false;
      this.$validator.reset();
      this.errors.clear();
    },
    resetSearch(){
      this.searchpermissionname = '';
      window.localStorage.removeItem("LSPermission")
      this.searchprojectid = '';
      this.pageno = 0;
      this.$refs.paginate.selected = 0;
      this.getPermisionData();
    },
    resetform() {
      this.addpermission.permissionid = '';
      this.addpermission.permissionname = '';
      this.permissionname = '';
      this.projectid=[];
      this.devicetype= "";
      this.is_active= "";
      this.ismenu="";
      this.addpermission.isEven = false;
      this.addpermission.backgroundColor = null;
      this.addpermission.textColor = null;
      this.checkedPerm_Id = [];
      this.listPermissionData= [];
      this.permissionid= [];
      this.getPermisionData();
    },
    searchPermisionData(){

      this.pageno = 0;
      this.$refs.paginate.selected = 0;
      this.getPermisionData();
    },
    closeStatusUrlModal() {
        this.modalShow = false
    },
    //to get target id in active/inactive modal
    getStatusRowData(data) {
        this.Statusaction = 'add'
        this.modalShow = true
        this.permissionid = data.permissionid
        this.is_active = data.is_active
        if (data.is_active == true)
        {
            this.changestatus = 'De-Activate'
        } else {
            this.changestatus = 'Activate'
        }
    },
    //for active/inactive modal
    changeUrlStatus() {
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');
        let reqpayload = ({
          'permissionid': this.permissionid,
          'is_active': this.is_active,
        })

        axios({
                method: 'POST',
                'url': apiUrl.api_url + 'updateurlStatus',
                'data': reqpayload,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
            .then((response) => {
                if (response.data.errorCode == 0) {
                    this.$alertify.success(response.data.msg);
                    this.addusermodal = false;
                    let permissionid = this.$route.params.id;
                    this.getPermisionData();
                } else if (response.data.errorCode == -1) {
                    this.$alertify.error(response.data.msg)
                }

                iptrackerdetails.checkUserIP(this.iptrackData,'Update Status Permission Modules',this.$route.path,reqpayload,response.data);

            })
            .catch((httpException) => {
                console.error('exception is:::::::::', httpException)
            })
    },
    getPermisionData(){
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      this.input = {
        offset: this.pageno,
        limit: 10,
        permissionname: this.searchpermissionname,
        searchprojectid: this.searchprojectid.projectid
      };

      window.localStorage.setItem("LSPermission",this.searchpermissionname)
      window.localStorage.setItem("LSProjectId",this.searchprojectid)
      window.localStorage.setItem("LSProjectId",this.searchprojectid.projectid)
      window.localStorage.setItem("LSProject",this.searchprojectid.projectname)
      this.isLoading = true;
      axios({
        method: "POST",
        url: apiUrl.api_url + "ApppermissionsMaster",
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      }).then(
        result => {
          this.listPermissionsData = result.data.data;
          this.isLoading = false;
          let totalRows = result.data.count;
          this.resultCount = result.data.data.length;
          if (totalRows < 10) {
            this.pagecount = 1;
          } else {
            this.pagecount = Math.ceil(totalRows / 10);
          }
        },
        error => {
          console.error(error);
        }
      );
    },

    savePermission(event) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      let reqpayload =({
        permissionname: this.addpermission.permissionname,
        projectid: this.projectid,
        parentid: this.parentid,
        controller_url: this.addpermission.controller_url,
        purl: this.addpermission.purl,
        sequence: this.addpermission.sequence,
        is_active: this.addpermission.is_active,
        roleids: this.roleid,
        ismenu: this.addpermission.ismenu,
        isEven: this.addpermission.isEven,
        backgroundColor: this.addpermission.backgroundColor,
        textColor: this.addpermission.textColor,
        createdby:this.localusername
      })
      axios({
          method: "POST",
          url: apiUrl.api_url + "SubmitAppPermissionData",
          data: reqpayload,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(response => {
            if (response.data.statuscode == 200) {
            this.$alertify.success("Permission Created Successfully");
            this.addpermissionmodal = false;
            event.target.reset();
            this.resetform();
          } else if (response.data.statuscode == 209) {
            this.$alertify.error("Permission Module Name Already Exist");
            //this.addpermissionmodal = false;
          } else if (response.data.statuscode == 400) {
            this.$alertify.error("Failed");
            this.addpermissionmodal = false;
          }
          iptrackerdetails.checkUserIP(this.iptrackData,'Add Application Modules',this.$route.path,reqpayload,response.data);

        })
        .catch(httpException => {
          console.error("exception is:::::::::", httpException);
        });
    },

    getPermissionRowData(data) {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      this.$validator.reset();
      this.errors.clear();
      this.permissionaction = "edit";
      this.addpermissionmodal = true;
      this.checkedPerm_Id = [];
      this.roleid = [];

      axios({
        method: "POST",
        url: apiUrl.api_url + "getAppPermissionsRoleData",
        data: {
          permissionid: data.permissionid
        },
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      }).then(
        result => {
          //console.log(result.data[0]["roleids"]);
          this.getProjectRoles_list(this.projectid);
          this.roleid = result.data[0]["roleids"];

        },
        error => {
          console.error(error);
        }
      );
      this.addpermission = data;
      this.addpermission.controller_url = data.controllerurl;
      this.addpermission.sequence = data.permsequence;
      this.addpermission.isEven = data.isEven;
      this.addpermission.backgroundColor = data.backgroundColor;
      this.addpermission.textColor = data.textColor;
      this.projectid = data.projectmaster.projectid;
      this.ismenu = data.ismenu;
      this.addpermission.is_active = data.is_active;
    },

    editPermission(event) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      let reqpayload =  {
        permissionname: this.addpermission.permissionname,
        permissionid: this.addpermission.permissionid,
        controllerurl: this.addpermission.controller_url,
        purl: this.addpermission.purl,
        permsequence: this.addpermission.sequence,
        projectid: this.projectid,
        is_active:this.addpermission.is_active,
        roleids: this.roleid,
        ismenu: this.addpermission.ismenu,
        modifiedby:this.localusername,
        isEven: this.addpermission.isEven,
        backgroundColor: this.addpermission.backgroundColor,
        textColor: this.addpermission.textColor
      }
      //var roleid = this.checkedPerm_Id.map(Number);
      axios({
          method: "POST",
          url: apiUrl.api_url + "UpdateAppPermission",
          data: {
            permissionname: this.addpermission.permissionname,
            permissionid: this.addpermission.permissionid,
            controllerurl: this.addpermission.controller_url,
            purl: this.addpermission.purl,
            permsequence: this.addpermission.sequence,
            projectid: this.projectid,
            is_active:this.addpermission.is_active,
            roleids: this.roleid,
            ismenu: this.addpermission.ismenu,
            modifiedby:this.localusername,
            isEven: this.addpermission.isEven,
            backgroundColor: this.addpermission.backgroundColor,
            textColor: this.addpermission.textColor
          },
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(response => {
          if (response.data.statuscode == 200) {
            this.$alertify.success("Permission updated successfully");
            this.addpermissionmodal = false;
            event.target.reset();
            this.resetform();
          } else if (response.data.statuscode == 209) {
            this.$alertify.error("Permission Module Name Already Exist");
            //this.addpermissionmodal = false;
          } else {
            this.$alertify.error("Permission failed to update");
            this.addpermissionmodal = false;
          }
          iptrackerdetails.checkUserIP(this.iptrackData,'Update App Permission Application Modules',this.$route.path,reqpayload,response.data);

        })
        .catch(httpException => {
          console.error("exception is:::::::::", httpException);
        });
    },

    //to get project list
    getAllProjectList() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getallprojects',
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listProjectData = result.data.data.rows;
        }, error => {
          console.error(error)
        })
    },

    getProjectRoles_list(project_id=null) {

      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      let projectid;
      if(project_id == null){
        projectid = this.projectid;
      }else{
        projectid = project_id;
      }
      if(projectid==null){
        return false;
      }
      this.input = {
        roletype: 2,
        projectid: project_id
      };
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getProjectRolesListData',
          data: this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listRolesData = result.data.data;
        }, error => {
          console.error(error)
        })
    },

    getPaginationData(pageNum) {
      this.pageno = (pageNum - 1) * 10;
      this.getPermisionData();
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          //console.log('form is valid', this.model);
          if(this.addpermission.permissionid!=undefined && this.addpermission.permissionid!=""){
            this.editPermission(event);
          }else{
            this.savePermission(event);
          }
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/components/apppermissions/apppermissions.component.js